import { render } from "./FotaManage.vue?vue&type=template&id=59447402&scoped=true"
import script from "./FotaManage.vue?vue&type=script&lang=js"
export * from "./FotaManage.vue?vue&type=script&lang=js"

import "./FotaManage.vue?vue&type=style&index=0&id=59447402&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59447402"]])

export default __exports__